
class StencilHTMLElement extends HTMLElement {
  name = "StencilHTMLElement";
  
  constructor() {
    super();
  }

  get logPrefix() {
    return `\x1b[30;41;1m[Element/${this.name.match(/[A-Z]/g).join("-")}]`;
  }

}

export default StencilHTMLElement;